import Field from "src/components/field/Field";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";

interface TaskModalContentProps extends Translation {}

const TaskModalContent = ({ t }: TaskModalContentProps) => {
	const { task, actions } = useTaskForm();

	return (
		<div className="flex flex-col gap-[6px]">
			<Field.Status
				wrapper={{ label: "Status", layout: "horizontal" }}
				value={task.status}
				onChange={(value) => {
					actions.set({
						status: value,
					});
				}}
			/>
			{/* <Field.Category
					wrapper={{ label: "Categorie", layout: "horizontal" }}
					value={
						task.category_id
							? task.category_id?.toString()
							: undefined
					}
					onChange={(value) => {
						actions.set({
							category_id: value,
						});
					}}
				/> */}
			<Field.Date
				wrapper={{ label: "Deadline", layout: "horizontal" }}
				value={task.end_date}
				onChange={(value) => {
					actions.set({
						end_date: value,
					});
				}}
			/>

			<Field.Tag
				canCreate
				wrapper={{ label: "Tags", layout: "horizontal" }}
				value={(task?.tags || []).map((tag: any) => tag?.tag || tag)}
				onChange={(tags) => {
					actions.set({
						tags,
					});
				}}
			/>

			<Field.Users
				wrapper={{
					label: t("fields.assignees.label"),
					layout: "horizontal",
				}}
				value={
					task.assignees
						? task.assignees.map((user: any) =>
								typeof user === "object"
									? user.id.toString()
									: user
						  )
						: []
				}
				onChange={(value) => {
					actions.set({
						assignees: value,
					});
				}}
			/>

			<Field.File
				wrapper={{
					label: t("fields.files.label"),
					layout: "horizontal",
				}}
				value={task?.media || []}
				onChange={(media) => {
					actions.set({
						media,
					});
				}}
			/>
			<hr className="border-dark-200 my-4 block" />
			<Field.Editor
				value={task.description}
				onChange={(value) => {
					actions.set({
						description: value,
					});
				}}
			/>
		</div>
	);
};

TaskModalContent.locale = {
	nl: {
		title: "",
		fields: {
			description: {
				placeholder: "Omschrijf de taak...",
			},
			files: {
				label: "Bestanden",
			},
			assignees: {
				label: "Uitvoerders",
			},
		},
	},
	en: {
		title: "",
		fields: {
			description: {
				placeholder: "Describe the task...",
			},
			files: {
				label: "Files",
			},
			assignees: {
				label: "Assignees",
			},
		},
	},
};

export default withTranslation(TaskModalContent);
